import { memo, useContext, useEffect, useState } from "react";
import { CardConfig, mapCardResponse } from "../../api/cardResponse.mapper";
import { getWidgetCMSData } from "../../api/widgetCmsData";
import {
  PlatformCMSUrl,
  WIDGET_CARDS_CONTENT_SLUG
} from "../../common";
import { ChevronIcon } from "../../icons/chevron";
import { InfoIcon } from "../../icons/info";
import { getBrowserLang } from "../../utils";
import { LocalizationContext } from "../context/LocalizationContext";
import styles from "./main-page.module.css";

export const InfoBlock = memo(() => {
  const localizationContext = useContext(LocalizationContext);
  const [isOpen, setIsOpen] = useState(false);
  const [infoBlocks, setInfoBlocks] = useState<CardConfig[]>([]);

  useEffect(() => {
    const loadData = async () => {
      const data = await getWidgetCMSData(
        PlatformCMSUrl(),
        WIDGET_CARDS_CONTENT_SLUG,
        getBrowserLang(),
      );

      setInfoBlocks(mapCardResponse(data!));
    };

    loadData();
  }, []);

  return (
    <>
      <div
        className={`${styles.infoBlockWrapper} ${isOpen ? styles.open : ""}`}
      >
        <div className={styles.infoBlockContentExpanded}>
          <div className={styles.infoBlockContent}>
            {infoBlocks.map((card) => (
              <div className={styles.infoCard} key={card.id}>
                <img
                  className={styles.infoCardImg}
                  src={card.mediaUrl}
                  alt={card.title}
                />
                <div className={styles.infoCardContent}>
                  <span className={styles.infoCardTitle}>{card.title}</span>
                  <span className={styles.infoCardText}>
                    {card.description}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.moreButton} onClick={() => setIsOpen(!isOpen)}>
          <InfoIcon />
          {isOpen ? localizationContext?.localization.modalhidebutton: localizationContext?.localization.modalmorebutton}
          <div className={styles.moreButtonArrow}>
            <ChevronIcon />
          </div>
        </div>
      </div>
    </>
  );
});
